import { styled } from 'styled-components';

export const Form = styled('form')(() => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
}));
